import Axios from "axios";

function Enrollment() {}

Enrollment.prototype.list = async function (filter = {}) {
  return await Axios.get("/users/enrollments", {
    params: filter,
  });
};

Enrollment.prototype.validate = async function (enrollment, id) {
  return await Axios.post("/enrollments/" + id + "/validate");
};

Enrollment.prototype.submit = async function (id) {
  return await Axios.post("/enrollments/" + id + "/submit");
};

Enrollment.prototype.get = async function (id) {
  return await Axios.get("/enrollments/" + id);
};

Enrollment.prototype.save = async function (enrollment, id) {
  return await Axios.put("/enrollments/" + id, enrollment);
};

Enrollment.prototype.addMember = async function (enrollmentId, memberId) {
  return await Axios.post(
    "/enrollments/" + enrollmentId + "/team/members/" + memberId,
  );
};

Enrollment.prototype.removeMember = async function (enrollmentId, memberId) {
  return await Axios.delete(
    "/enrollments/" + enrollmentId + "/team/members/" + memberId,
  );
};

Enrollment.prototype.classify = async function (eventId, enrollmentId) {
  return await Axios.post(
    "/enrollments/" + enrollmentId + "/classify/" + eventId,
  );
};

// Expose Singleton
export default new Enrollment();



// WEBPACK FOOTER //
// ./src/services/Enrollment.js